import UIConfig from './UIConfig'

export default class ProcessBuilderUIConfig extends UIConfig {

}
